module.exports = __webpack_public_path__ + "static/media/dhre.b813e240.jpg";